import { configureStore } from '@reduxjs/toolkit';
import { reducers } from '../slices';

export const store = configureStore({ reducer: reducers, devTools: true });

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
